import React from "react"
import Layout from "../components/layout"
import Privacy from "../components/privacy"

const PrivacyPageEn = () => {
  return (
    <Layout>
      <Privacy title="Privacy Policy">
        <ul>
          <li>
            "Use of Advertising ID"
            <ul>
              <li>
                A unique ID is used when displaying advertising. This is the
                viewpoint of "data transmitted from an application". I clearly
                stated to use it.
              </li>
            </ul>
          </li>
          <li>
            "Network Access"
            <ul>
              <li>It is used for advertisement display in the application.</li>
            </ul>
          </li>
          <li>Other than above, personal information is not used.</li>
        </ul>
      </Privacy>
    </Layout>
  )
}

export default PrivacyPageEn
